import Navigation from './Navigation.jsx';
import styles from './Footer.module.scss';

export default function Footer() {
  return (
    <footer className={styles.Footer}>
      <Navigation />
    </footer>
  );
}
